import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/mnt/d/Projects/newcold-web/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/node_modules/maplibre-gl/dist/maplibre-gl.css");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/components/CustomLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/HamburgerMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/NewsletterForm.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/styles/globals.css");
